import headNav from '@src/components/head_nav'
import inviteCodeRule from '../components/inviteCodeRule'
import inviteIcon from "../images/inviteIcon.webp"
import inviteIcon_block from "../images/inviteIcon_block.webp"
import awardDialog from '@src/components/awardDialog'
import defaultPage from '@src/pages/index/components/defaultPage.vue'
import util from "@src/utils/util.js"
import { JsBridge, ActStat } from '@ie-activity/oversea-act-js-lib'
import { bindInviteCode, getInviteRelation, getInviteReward, getInviteActivityInfoByActId } from './services'
import clear from "../images/clear.webp"
import clear_dark from "../images/clear_dark.webp"
let vm = {
  components: {
    headNav,
    awardDialog,
    inviteCodeRule,
    defaultPage
  },
  data() {
    return {
      clear,
      clear_dark,
      isDetail: false,
      showTip: true,
      inviteIcon,
      inviteIcon_block,
      isShowAwardDialog: false,
      userRewardRsp: {},
      isNight: false,
      isActivite: false,
      inputValue: '',
      isInviteCode: false,
      isInputLine: false,
      inputField: '',
      inviteTypeSingin: false,
      errorMessage: '',
      rewardType: '',
      inviteTipDesc: '',
      rewardInvitedNum: 0,
      symbol: '',
      isBinding: false,
      inviteOption: {},
      codeInfo: null,
      inviteTipOption: {},
      isInvite: true,
      InviteRelationData: '', // 链接信息
      isshowInput: false,
      isshowinvited: false,
      defaultPageOptions: {},
      isShowDefaultPage: false,
    };
  },
  computed: {
    clearUrl() {
      if (this.isNight) {
        return clear_dark
      } else {
        return clear
      }
    },
    inviteUrl() {
      if (this.isNight) {
        return inviteIcon_block
      } else {
        return inviteIcon
      }
    }
  },
  async mounted() {
    this.isNight = util.isNight()
    console.log(window.loading, "99999999999")
    if (window.loading && window.loading.isPaused) {
      window.loading.play()
    }
    this.setStatusBarFontColor(false)
    this.getInviteActivityInfoByActId()
    this.getInviteRelation()
    this.inputValue = this.$refs.input.value
    this.inputField = this.$refs.input
  },
  methods: {
    // gotIt() {
    //   ActStat.reportCustom('closeAwardSuccessDialog')
    //   this.isShowAwardDialog = false
    //   JsBridge.openActivity('oap://qg/mine')
    // },
    setStatusBarFontColor(isWhiteFont) {
      if (JsBridge.getEnv() === 'gameHall') {
        window.android.setStatusBarFontColor(isWhiteFont)
      }
    },
    endLoading() {
      let loading = document.getElementById('index-loading')
      if (loading) {
        window.loading && window.loading.stop()
        loading.style.display = 'none'
      }
    },
    onfocusEvent() {
      this.isActivite = true
    },
    onblurEvent() {
      if (this.inputValue) return
      this.isActivite = false
    },
    clearEvent() {
      this.inputValue = ""
      this.isInputLine = false
      this.isInviteCode = false
      this.inputField.focus()
    },
    oninputEvent() {
      this.isInputLine = false
      this.isInviteCode = false
    },
    errorEvent() {
      this.inputField.classList.add('input');
      let that = this
      setTimeout(function () {
        that.inputField.classList.remove('input')
      }, 1000);
      this.isInviteCode = true
      this.isInputLine = true
      this.inputField.setSelectionRange(0, this.inputField.value.length)
      this.inputField.focus()
    },
    submitEvent() {
      if (this.inputValue) {
        if (this.isBinding === true) {
          return
        }
        this.isBinding = true
        this.bindInviteCode()
      }
    },
    initInvitePage() {
      if(this.InviteRelationData.enterCode) {
        this.isshowInput =  false
        this.isshowinvited = true
        if(this.InviteRelationData.hasFinishBind) {
          if(!this.InviteRelationData.hasAward) {
            this.setToWithdrawOption()
          }
        }else{
          this.setToFinishTaskOption()
        }
      }else{
        this.isshowInput =  true
        this.isshowinvited = false
      }
      this.endLoading()
    },
    async bindInviteCode() {
      let { activityId } = this.$route.query
      let res = await bindInviteCode({ activityId, inviteCode: this.inputValue })
      if (res.code === "2000") {
        ActStat.reportCustom('inviteClickSubmitSuccessbutton')
        if (this.rewardType === 1) {
          JsBridge.makeToast(this.$t('inviteCode.submitSucccess'))
          setTimeout(function () {
            JsBridge.openActivity('oap://qg/mine')
          }, 2000);
        }
        if (this.rewardType === 2) {
          ActStat.reportCustom('inviteAwardSuccessDialog')
          this.isShowAwardDialog = true
          this.getInviteRelation()
          // 已输入邀请码，未完成新手任务，去完成
          if(this.InviteRelationData.hasFinishBind) {
            if(this.InviteRelationData.hasAward) {
              this.isShowAwardDialog = false
            }else{
              this.setToWithdrawTipOption()
            }
          }else{
            this.setToFinishTaskTipOption()
          }
          this.inputField.blur()
        }
      } else {
        ActStat.reportCustom('inviteClickSubmitFailbutton')
        if (res.code === "5607") {
          this.errorEvent()
          this.errorMessage = this.$t('inviteCode.inviteCodeError')
        }
        if (res.code === "5608") {
          this.errorEvent()
          this.errorMessage = this.$t('inviteCode.inviteCodeRegion')
        }
        if (res.code === "5609") {
          this.errorEvent()
          this.errorMessage = this.$t('inviteCode.phoneSame')
        }
      }
      this.isBinding = false
    },
    async getInviteActivityInfoByActId() {
      let { activityId } = this.$route.query
      if (!activityId) {
        this.setOfflineOptions()
        return
      }
      let res = await getInviteActivityInfoByActId({ activityId })
      if (res && res.code === 'failed' && res.message === 'Network Error') {
        this.isShowDefaultPage = true
        this.setnotInternetOption()
        this.setStatusBarFontColor(false)
        return
      }
      if (res.code === '5604') {
        this.setOfflineOptions()
        this.setStatusBarFontColor(false)
        this.isShowDefaultPage = true
      }
      if(res.code === '2000') {
        let data = res.data
        this.rewardType =  data.rewardType
        this.inviteTipDesc =  data.inviteTipDesc
        this.rewardInvitedNum =  data.rewardInvitedNum / 100
        this.symbol =  data.symbol
        if (this.rewardType === 1) {
          this.inviteTypeSingin = true
        }
      }
    },
    async getInviteRelation() {
      this.isShowDefaultPage = false
      let data = await getInviteRelation({ isInvite: this.isInvite })
      if(data) {
        this.InviteRelationData = data
        this.initInvitePage()
      }
      if(!data.jumpInviteUrl) {
        this.isShowDefaultPage = true
        this.setOfflineOptions()
      }
    },
    async getInviteReward() {
      let { activityId } = this.$route.query
      let res = await getInviteReward({ activityId })
      if (res.code === "2000") {
        JsBridge.openActivity('oap://qg/mine/mywallet')
      }
    },
    // 已输入邀请码页面
    setToFinishTaskOption() {
      let that = this
      this.inviteOption = {
        entertedText: this.$t('inviteCode.invitationCodeEntered'),
        extraCashText: this.$t('inviteCode.getCashAward', [this.symbol + this.rewardInvitedNum]),
        tipText: this.$t('inviteCode.toCompleteTask'),
        submit: this.$t('inviteCode.toComplete'),
        submitEvent() {
          // 条件判断
          if(!that.InviteRelationData.jumpBindUrl) {
            that.isShowDefaultPage = true
            that.setOfflineOptions()
            return;
          }
          let deepLink = `oaps://qg/web?weburl=${encodeURIComponent(that.InviteRelationData.jumpBindUrl)}`
          JsBridge.openActivity(deepLink)
        }
      }
    },
    setToWithdrawOption() {
      let that = this
      this.inviteOption = {
        entertedText: this.$t('inviteCode.invitationCodeEntered'),
        extraCashText: this.$t('inviteCode.getCashAward', [this.symbol + this.rewardInvitedNum]),
        tipText: this.$t('inviteCode.finishTaskgetCash'),
        submit: this.$t('inviteCode.toWithdraw'),
        submitEvent() {
          that.getInviteReward() // 先领取再跳转钱包详情页
        }
      }
    },

    // 弹框词条
    setToFinishTaskTipOption() {
      let that = this
      this.inviteTipOption = {
        dialogTip: this.$t('inviteCode.getCashAward', [this.symbol + this.rewardInvitedNum]),
        awardTip: this.$t('inviteCode.toCompleteTask'),
        btnText: this.$t('inviteCode.toComplete'),
        btnEvent() {
          that.isShowAwardDialog = false
          if(!that.InviteRelationData.jumpBindUrl) {
            that.isShowDefaultPage = true
            that.setOfflineOptions()
            return;
          }
          let deepLink = `oaps://qg/web?weburl=${encodeURIComponent(that.InviteRelationData.jumpBindUrl)}`
          JsBridge.openActivity(deepLink)
        }
      }
    },
    setToWithdrawTipOption() {
      let that = this
      this.inviteTipOption = {
        dialogTip: this.$t('inviteCode.getCashAward', [this.symbol + this.rewardInvitedNum]),
        awardTip: this.$t('inviteCode.finishTaskgetCash'),
        btnText: this.$t('inviteCode.toWithdraw'),
        btnEvent() {
          that.isShowAwardDialog = false
          that.getInviteReward()
        }
      }
    },
    setOfflineOptions() {
      let that = this
      this.defaultPageOptions = {
        content: this.$t('inviteDetail.gamesOffline'),
        btnText: this.$t('inviteDetail.seeMoreGames'),
        btnEvent: function () {
          if (JsBridge.getEnv() === 'gameHall') {
            JsBridge.openActivity('oap://qg/home')
          } else {
            let query = that.$route.query
            that.$router.push({ name: 'sharePage', query: { ...query, status: that.status } })
          }
        },
      }
    },
    setnotInternetOption() {
      let that = this
      this.defaultPageOptions = {
        content: this.$t('inviteDetail.networkErr'),
        isUpgrade: true,
        btnText: this.$t('inviteDetail.refresh'),
        isInternet: true,
        async btnEvent() {
          that.isShowDefaultPage = false
          that.startLoading()
          await that.getInviteActivityInfoByActId()
          that.endLoading()
        },
      }
    },
  }
};

export default vm;



// WEBPACK FOOTER //
// ./src/pages/inviteCodePage/scripts/index.js